import React from 'react'
import { render } from 'react-dom'
import { HelmetProvider } from 'react-helmet-async'

import MetaInfo from 'components/common/MetaInfo'
import ErrorFallback from 'components/ErrorFallback'

import App from './App'
import { initializeApp } from './initialize/initializeApp'
import { ERROR_MESSAGES } from './initialize/initializeErrorMessage'
import reportWebVitals from './reportWebVitals'

import 'core-js/stable'
import 'regenerator-runtime/runtime'

// 루트 엘리먼트를 한 번만 찾아서 캐시
const getRootElement = (() => {
  const rootElement = document.getElementById('root')
  if (!rootElement) {
    throw new Error(ERROR_MESSAGES.ROOT_NOT_FOUND)
  }
  return () => rootElement
})()

function renderErrorFallback(rootElement, error) {
  render(<ErrorFallback error={error} />, rootElement)
}

function renderApp(rootElement) {
  try {
    render(
      <React.StrictMode>
        <HelmetProvider>
          <MetaInfo />
          <App />
        </HelmetProvider>
      </React.StrictMode>,
      rootElement
    )
  } catch (error) {
    console.error('Failed to render app:', error)
    renderErrorFallback(rootElement, error)
  }
}

// 앱 초기화 및 렌더링
const initializeApplication = async () => {
  try {
    await initializeApp()
    const rootElement = getRootElement()
    renderApp(rootElement)
  } catch (error) {
    console.error('Failed to bootstrap app:', error)
    const rootElement = getRootElement()
    if (rootElement) {
      renderErrorFallback(rootElement, error)
    }
  }
}

// 앱 시작
initializeApplication()

// 성능 측정
reportWebVitals()
